export default function GlobalPresence() {
  const regions = [
    {
      name: 'Europe',
      countries: 18,
      icon: 'ri-map-pin-line',
      color: 'blue',
      cities: 'Paris, London, Berlin, Madrid, Rome'
    },
    {
      name: 'North America',
      countries: 3,
      icon: 'ri-map-pin-line',
      color: 'green',
      cities: 'New York, Los Angeles, Toronto, Mexico City'
    },
    {
      name: 'South America',
      countries: 6,
      icon: 'ri-map-pin-line',
      color: 'blue',
      cities: 'São Paulo, Buenos Aires, Lima, Santiago'
    },
    {
      name: 'Africa',
      countries: 8,
      icon: 'ri-map-pin-line',
      color: 'green',
      cities: 'Lagos, Cairo, Johannesburg, Nairobi'
    },
    {
      name: 'Asia',
      countries: 12,
      icon: 'ri-map-pin-line',
      color: 'blue',
      cities: 'Singapore, Tokyo, Dubai, Mumbai, Shanghai'
    },
    {
      name: 'Oceania',
      countries: 3,
      icon: 'ri-map-pin-line',
      color: 'green',
      cities: 'Sydney, Melbourne, Auckland, Brisbane'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Global Presence
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Operating in over 50 countries across 6 continents, TrackVerse provides 
            seamless logistics solutions with local expertise and global reach.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {regions.map((region, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <div className={`w-12 h-12 bg-${region.color}-100 rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${region.icon} text-2xl text-${region.color}-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{region.name}</h3>
              <div className="text-3xl font-bold text-blue-600 mb-4">
                {region.countries} <span className="text-base font-normal text-gray-600">Countries</span>
              </div>
              <p className="text-sm text-gray-600">
                <strong>Key Cities:</strong> {region.cities}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-lg p-8 border border-gray-200">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">150+</div>
              <div className="text-sm text-gray-600">Distribution Centers</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">5,000+</div>
              <div className="text-sm text-gray-600">Team Members</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">200+</div>
              <div className="text-sm text-gray-600">Partner Networks</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">99.2%</div>
              <div className="text-sm text-gray-600">On-Time Delivery</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
